import {AppState} from '@app/context/context';

const CLIENTS_COLUMNS_KEY = 'clientsColumns';

class ClientsColumnsStorage {
    set = (config: AppState['clients']['config']) =>
        localStorage.setItem(CLIENTS_COLUMNS_KEY, JSON.stringify(config));

    get = (): AppState['clients']['config'] | null => {
        const storedConfig = localStorage.getItem(CLIENTS_COLUMNS_KEY);
        return storedConfig ? JSON.parse(storedConfig) : null;
    };

    clear = () => localStorage.removeItem(CLIENTS_COLUMNS_KEY);
}

export const clientsColumnsStorage = new ClientsColumnsStorage();